(function (window, $) {

	$.nette.init();

	document.addEventListener('DOMContentLoaded', () => {

		// Swiper v detailu e-shopu
		const eshopSwiperThumbs = new Swiper('.js-eshop-swiper-thumbs', {
			slidesPerView: 'auto',
			freeMode: true,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
		});

		new Swiper('.js-eshop-swiper', {
			loopedSlides: 3,
			navigation: {
				nextEl: '.swiper-button--next',
				prevEl: '.swiper-button--prev',
			},
			thumbs: {
				swiper: eshopSwiperThumbs,
			},
			loop: false,
			mode: 'carousel'
		});
	});

	$.nette.ext('live').after(function ($el) {
		$el.find(".js-itemAmount").c('itemAmount');
		$el.find("[data-app-item-size-picker]").c('itemSizePicker');
		$el.find('.js-cart-item-delete').on('click', function (e) {
			$(this).closest('form').find('[name="removeFromCart"]').netteAjax(e);
		});
	});

	$.nette.ext('error', {
		error: function (jqXHR) {
			if (jqXHR.responseText !== undefined) { // Když AJAX neproběhne, protože ho prohlížeč zruší (asi při více paralelních AJAXech), tak nemá responseText.
				alert(jqXHR.responseText);
			}
		},
	});

})(window, jQuery);